export default __webpack_public_path__ + "static/2-bb99ceb3dbb0b1cd8eeef237997e300d.png";